import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordView } from '@/modules/auth';
import { PageMetadata } from '@/app/PageMetadata';

export const Route = createFileRoute('/forgot-password')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageMetadata title="Forgot Password | Self Inspection" />
      <ForgotPasswordView />
    </>
  );
}
